import { showContact as openContact, PositionCode, showDynamicQrcode } from '@youyan/common';
import { debounce } from 'lodash-es';

export const showContact = debounce((name?: string) => {
  if (isChinese()) {
    openContact(name ? getFeUrl(`/youyan-platform/png/qrcode/drainage/${name}.png`) : name);
  } else {
    // 海外留资
    window.open('/contact-us');
  }
}, 200);

export const showContactNew = (url?: string) => {
  if (isChinese()) {
    openContact(url);
  } else {
    // 海外留资
    window.open('/contact-us');
  }
};

// 显示动态二维码
export const showDynamicContact = async (code: PositionCode) => {
  if (isChinese()) {
    showDynamicQrcode(code);
  } else {
    // 海外留资
    window.open('/contact-us');
  }
};

export const subscribeContact = () => {
  // showContactNew(getQrcodeURI('b', '28'));
  showDynamicContact(PositionCode['有言官套餐网权益页面专属定制']);
};
